import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Code } from "lucide-react";
import { ProgressIndicator } from "./ProgressIndicator";
import { Student } from "@/types/classroom";

interface StudentsTableProps {
  students: Student[];
  workspacesActive: boolean;
}

export const StudentsTable = ({
  students,
  workspacesActive,
}: StudentsTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[300px]">Student Name</TableHead>
          <TableHead>Progress</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {students.map((student) => (
          <TableRow key={student.workspace_id}>
            <TableCell className="font-medium">
              <div className="flex items-center gap-3">
                <Avatar className="w-8 h-8">
                  <AvatarFallback>
                    {student.name && student.name[0]}
                  </AvatarFallback>
                </Avatar>
                <span>{student.name}</span>
              </div>
            </TableCell>
            <TableCell>
              {workspacesActive ? (
                <ProgressIndicator
                  courseId={import.meta.env.VITE_COURSE_ID}
                  workspaceId={student.workspace_id}
                />
              ) : (
                <span>-</span>
              )}
            </TableCell>
            <TableCell className="text-right flex justify-end">
              <a
                href={student.url}
                target="_blank"
                rel="noreferrer noopener nofollower"
              >
                <Button
                  variant="outline"
                  className="flex items-center gap-2 text-purple-700 border-purple-700 hover:bg-purple-50"
                >
                  <Code className="h-4 w-4" />
                  Coding Space
                </Button>
              </a>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default StudentsTable;
